module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-7.cb8175b0.mp3";